export default {
    price: 1000,
    light: {
        primary: '#DF760C',
        secondary: '#424242',
        accent: '#FFC182',
    },
    dark: {
        primary: '#DF760C',
        secondary: '#424242',
        accent: '#FFC182',
    }
}
